/**
 * Catálogo canônico da Verificação Proativa Pós-Resolução — ADR-149
 * (materialização v1 da ADR-104 ScheduledOutboundAction, fonte única
 * `playbook_verification`).
 *
 * Fonte da verdade triangulada (R15):
 * - **Semântica**: spec Fase 0 ratificada
 *   (`docs/superpowers/specs/2026-06-11-verificacao-proativa-fase0-catalogo-adr149-draft.md`)
 *   + mockup aba 6 (`design-references/brief-4/r5/shared/fixtures-4.js:305-318`).
 * - **IDs das condições**: casam com as fixtures do mockup (kebab-case).
 * - **Classificação honesta** (molde ADR-148): TODAS as 5 condições são
 *   `enforce-now` — queries determinísticas no momento do close (Pendency /
 *   QualitySignals / Appointment / CustomerCommitment / timestamps). Não há
 *   LLM nem detector novo no disparo.
 * - **Default off** (P12 — proatividade é opt-in): `Playbook.verification`
 *   null ou `enabled !== true` ⇒ zero disparo (comportamento atual).
 *
 * Mudança de semântica (condição nova, default) = via humano + incremento de
 * `PROACTIVE_VERIFICATION_CATALOG_VERSION` (molde régua v3.238 / ADR-148).
 */
export const PROACTIVE_VERIFICATION_CATALOG_VERSION = 1;
/** Opções canônicas de espera pós-encerramento (mockup aba 6). */
export const VERIFICATION_WAIT_HOURS_OPTIONS = [1, 4, 12, 24, 48, 168];
export const DEFAULT_VERIFICATION_WAIT_HOURS = 24;
/**
 * Modo de operação da conversa de verificação (ADR-030):
 *   - `H_c` — IA conduz (conductor; Gatilhos de Proteção ADR-148 aplicam).
 *   - `H_b` — IA envia o template e para; resposta do cliente cai no inbox.
 *   - `H_a` — sistema NÃO envia nada; cria Pendency para o atendente disparar
 *     manualmente via Iniciar Conversa Proativa (Brief 2B T8).
 */
export const VERIFICATION_MODES = ['H_a', 'H_b', 'H_c'];
export const DEFAULT_VERIFICATION_MODE = 'H_c';
/** Limiar da condição `long-attendance` (mockup: "atendimento durou >30 minutos"). */
export const LONG_ATTENDANCE_THRESHOLD_MINUTES = 30;
export const VERIFICATION_CONDITION_CATALOG = [
    {
        id: 'pending-pendency',
        label: 'Encerramento com pendência aberta',
        description: 'A conversa foi encerrada com ao menos uma Pendency vinculada ainda aberta (open/in_progress/postponed) — o problema pode não ter sido de fato resolvido.',
        defaultEnabled: true,
    },
    {
        id: 'low-sentiment',
        label: 'Sentimento baixo detectado durante o atendimento',
        description: 'QualitySignals da conversa indicam sentimento negativo/hostil ou em deterioração (sentimentTrend=descending) — vale confirmar se o cliente saiu atendido.',
        defaultEnabled: true,
    },
    {
        id: 'tech-visit-completed',
        label: 'Visita técnica concluída',
        description: 'Há Appointment vinculado à conversa com status completed — verificar se a intervenção em campo resolveu (provedor: OS; clínica: pós-consulta; varejo: pós-entrega).',
        defaultEnabled: true,
    },
    {
        id: 'customer-commitment',
        label: 'Cliente assumiu compromisso',
        description: 'Há CustomerCommitment pendente vinculado à conversa — acompanhar o cumprimento do que o cliente disse que faria.',
        defaultEnabled: false,
    },
    {
        id: 'long-attendance',
        label: 'Atendimento longo (>30 minutos)',
        description: 'A conversa durou mais de 30 minutos entre criação e encerramento — atendimentos longos merecem follow-up de satisfação.',
        defaultEnabled: false,
    },
];
export const VERIFICATION_CONDITION_IDS = VERIFICATION_CONDITION_CATALOG.map((c) => c.id);
export function getVerificationCondition(id) {
    return VERIFICATION_CONDITION_CATALOG.find((c) => c.id === id) ?? null;
}
//# sourceMappingURL=catalog.js.map